(function () {
  var QUOTE_TAG = 'quoteneeded';
  var FORM_BASE_URL = 'https://varsity.tfaforms.net/f/request-shipping-quote';

  function hasQuoteTag(tagsStr) {
    if (!tagsStr) return false;
    return tagsStr.split(',').some(function (t) {
      return t.trim().toLowerCase() === QUOTE_TAG;
    });
  }

  function buildQuoteUrl(title, productUrl) {
    return FORM_BASE_URL
      + '?tfa_27=' + encodeURIComponent(title || '')
      + '&tfa_31=' + encodeURIComponent(productUrl || '');
  }

  function getSelectedVariantTitle(scope) {
    var options = [];
    scope.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
      if (!input.closest('product-variants, .product-variants, [data-js-product-variant-container]')) return;
      var label = scope.querySelector('label[for="' + input.id + '"]');
      var text = label ? label.textContent.trim() : input.value;
      if (text) options.push(text);
    });
    scope.querySelectorAll('select[data-js-product-variant-container="select"], select[name*="option"]').forEach(function (sel) {
      if (sel.value) options.push(sel.value);
    });
    return options.join(' / ');
  }

  function buildQuoteButton(title, productUrl, inheritClasses, scope) {
    var a = document.createElement('a');
    a.href = buildQuoteUrl(title, productUrl);
    a.className = 'quote-needed-btn ' + (inheritClasses || 'button button--solid button--product');
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener');
    a.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;gap:10px;text-decoration:none;box-sizing:border-box;flex-grow:10;';
    a.innerHTML = 'Request Quote';

    // Recompute URL at click time to capture currently selected variant
    if (scope) {
      a.addEventListener('click', function () {
        var variant = getSelectedVariantTitle(scope);
        var fullTitle = variant ? title + ' - ' + variant : title;
        this.href = buildQuoteUrl(fullTitle, productUrl);
      });
    }

    return a;
  }

  function suppressElement(el) {
    el.style.setProperty('display', 'none', 'important');
    el.setAttribute('aria-hidden', 'true');
  }

  function processScope(scope) {
    if (!scope || scope.dataset.quoteHandled) return;
    scope.dataset.quoteHandled = 'true';

    var title = scope.dataset.productTitle
      || (scope.querySelector && scope.querySelector('.product__title') && scope.querySelector('.product__title').textContent.trim())
      || (document.querySelector('h1.product__title') && document.querySelector('h1.product__title').textContent.trim())
      || document.title.split('\u2013')[0].trim()
      || '';
    var productUrl = scope.dataset.productUrl || window.location.href;

    var ATC_SELECTORS = [
      '[data-js-product-add-to-cart]',
      'button[data-js-atc]',
      'button[name="add"]',
      '.add-to-cart',
      '.quick-add__submit',
      '.card__add-button'
    ];

    var variantScope = scope;
    if (scope.matches && scope.matches('sticky-add-to-cart')) {
      variantScope = document.getElementById(scope.dataset.id) || scope;
    }

    function injectQuoteButton() {
      ATC_SELECTORS.forEach(function (sel) {
        scope.querySelectorAll(sel).forEach(function (btn) {
          if (btn.classList.contains('quote-needed-btn')) return;

          // <a> tag = quick-view modal trigger — keep click behavior, just relabel it
          if (btn.tagName === 'A') {
            btn.textContent = 'Get a Quote';
            btn.classList.remove('button--loader');
            btn.classList.add('quote-needed-btn');
            return;
          }

          // <button> tag = real ATC button — hide and replace with form link
          if (btn.nextElementSibling && btn.nextElementSibling.classList.contains('quote-needed-btn')) return;

          var inherited = Array.from(btn.classList)
            .filter(function (c) {
              return c !== 'disabled' && c !== 'button--loader' && c !== 'add-to-cart';
            })
            .join(' ');

          suppressElement(btn);
          btn.insertAdjacentElement('afterend', buildQuoteButton(title, productUrl, inherited, variantScope));
        });
      });

      // Hide duplicate price inside buy_buttons block
      scope.querySelectorAll('.product-actions__price').forEach(suppressElement);

      // Hide quantity selector
      scope.querySelectorAll(
        'product-quantity, [data-js-product-quantity], .product-quantity, .quantity-selector'
      ).forEach(suppressElement);

      // Hide dynamic checkout buttons
      scope.querySelectorAll(
        '.shopify-payment-button, .dynamic-checkout__content, .product-form__payment-container'
      ).forEach(suppressElement);
    }

    injectQuoteButton();

    // Re-run on DOM changes to catch custom element re-renders
    var innerObserver = new MutationObserver(function () {
      injectQuoteButton();
    });
    innerObserver.observe(scope, { childList: true, subtree: true });
  }

  function scanForTaggedCards(root) {
    (root || document).querySelectorAll('[data-product-tags]').forEach(function (el) {
      if (hasQuoteTag(el.getAttribute('data-product-tags'))) {
        processScope(el);
      }
    });
  }

  var fetchCache = {};
  function fetchProductData(handle) {
    if (fetchCache[handle]) return fetchCache[handle];
    fetchCache[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
    return fetchCache[handle];
  }

  function getHandleFromNode(node) {
    var link = node.querySelector('a[href*="/products/"]');
    if (link) {
      var m = link.href.match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    return null;
  }

  var globalObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        // Tagged ancestor
        var tagged = node.closest && node.closest('[data-product-tags]');
        if (tagged && hasQuoteTag(tagged.getAttribute('data-product-tags'))) {
          processScope(tagged);
          return;
        }

        // Tagged descendants
        scanForTaggedCards(node);

        // Untagged modal with cart form — fetch to check tags
        if (node.querySelector && node.querySelector('form[action*="/cart/add"]')) {
          var handle = getHandleFromNode(node);
          if (handle) {
            fetchProductData(handle).then(function (data) {
              if (!data) return;
              var isQuote = (data.tags || []).some(function (t) {
                return t.toLowerCase() === QUOTE_TAG;
              });
              if (isQuote) {
                if (!node.dataset.productTitle) node.dataset.productTitle = data.title;
                if (!node.dataset.productUrl) node.dataset.productUrl = window.location.origin + data.url;
                if (!node.dataset.productTags) node.dataset.productTags = (data.tags || []).join(',');
                processScope(node);
              }
            });
          }
        }
      });
    });
  });

  function init() {
    // PDP fallback via ShopifyAnalytics
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if (meta && meta.product) {
      var isQuote = (meta.product.tags || []).some(function (t) {
        return t.toLowerCase() === QUOTE_TAG;
      });
      if (isQuote) {
        var pdpScope = document.querySelector('[data-product-tags]') ||
                       document.querySelector('product-page') ||
                       document.querySelector('.product');
        if (pdpScope) {
          if (!pdpScope.dataset.productTitle) pdpScope.dataset.productTitle = meta.product.title || '';
          if (!pdpScope.dataset.productUrl) pdpScope.dataset.productUrl = window.location.origin + (meta.product.url || window.location.pathname);
          processScope(pdpScope);
        }
      }
    }

    scanForTaggedCards(document);
    globalObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
